import { Component, HostBinding, Input, Output } from "@angular/core";
import { NotificationsService } from "@tytapp/notifications";
import { Observable, Subject } from "rxjs";

@Component({
    selector: 'tyt-nav-avatar',
    template: `
        <button
            (click)="activate()"
            [class.notifications-visible]="notificationsVisible"
            [style.background-image]="backgroundImage"
            aria-label="Your profile, settings, and notifications"
            >
            <span [class.active]="count > 0" class="indicator">{{count}}</span>
        </button>
    `,
    styles: [`
        button {
            cursor: pointer;
            background-size: cover;
            background-position: center;
            background-color: black;
            width: 32px;
            height: 32px;
            display: inline-block;
            vertical-align: middle;
            border: 2px solid #FFF;
            position: relative;
            margin-right: 10px;
            appearance: none;
        }

        button.active {
            border-color: '#003FE7';
        }

        .indicator {
            position: absolute;
            top: -12px;
            right: -12px;
            display: grid;
            place-items: center;
            font-size: 11px;
            background-color: #CCC;
            opacity: 1;
            transition: all 400ms ease-in-out;
            width: 20px;
            height: 20px;
            color: black;
        }


        .indicator.active {
            background-color: #FF0000;
            color: white;
        }

    `]
})
export class NavAvatarComponent {

    constructor(
        private notifications: NotificationsService
    ) {
    }

    @Input() image: string;
    @Input() count = 0;

    @Output()
    activated = new Subject<void>();

    get backgroundImage() {
        return `url(${this.image || '/assets/new-avatar.png'})`;
    }

    get notificationsVisible() {
        return this.notifications.visible;
    }

    activate() {
        this.activated.next();
    }

}